import { STATUS_PROCESS } from "libs/configs/constant";
import { get } from "lodash";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addSmartForm as postAddSmartForm,
  getSmartForm as fetchSmartForm,
  selectAddSmartForm,
  selectCurrentDocument,
  selectCurrentSmartForm,
  selectDraftId,
  selectSubmitSmartForm,
} from "redux/modules/visaForm";

export default function useSmartForm() {
  const dispatch = useDispatch();
  const draftId = useSelector(selectDraftId);
  const submitSmartFormState = useSelector(selectSubmitSmartForm);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);
  const currentDocument = useSelector(selectCurrentDocument);

  const fileDocument = get(smartform, "fileDocument", []);
  const condition = get(smartform, "condition", []);
  const typeDocSmartFromID = get(smartform, "typeDocSmartFromID");
  const statausID = get(smartform, "statausID", "");
  const isTypeChange = typeDocSmartFromID === "C";
  const isExtension = typeDocSmartFromID === "E";
  const isDepartmentRequestDoc = statausID === STATUS_PROCESS.RequestAddDoc;

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(smartform, "detail", []).reduce(
    smartNameById,
    {}
  );
  const ConditionType = get(smartformDetail, "ConditionType.value", "");

  const getSmartForm = useCallback(
    ({ smartserviceId, draftId, personalId }) =>
      dispatch(
        fetchSmartForm({
          smartserviceId,
          draftId,
          personalId,
        })
      ),
    [dispatch]
  );

  const addSmartForm = useCallback(
    ({ data }) =>
      dispatch(
        postAddSmartForm({
          data,
        })
      ),
    [dispatch]
  );

  return {
    addSmartFormState,
    submitSmartFormState,
    draftId,
    smartform,
    fileDocument,
    condition,
    getSmartForm,
    addSmartForm,
    currentDocument,
    isTypeChange,
    isExtension,
    isDepartmentRequestDoc,
    ConditionType,
  };
}
